module.exports = __webpack_public_path__ + "5ffc8681618a2cb82fa2ef28befbc290.jpg";